import React from "react";
import { useNavigate } from "react-router-dom";

const ExtraActivityCard = ({ icon, title, description }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white p-[30px] rounded-lg shadow-md">
      <div className="flex justify-center mb-4">
        <img src={icon} alt={`${title} Icon`} className="h-16 w-16" />
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600 mb-4 text-base">{description}</p>
      <button
        className="bg-secondary_main text-white font-bold text-base px-4 py-2 rounded"
        onClick={() =>
          navigate(`/extra-curricular/${title}`, {
            state: { description: description },
          })
        }
      >
        View More
      </button>
    </div>
  );
};

export default ExtraActivityCard;
